import { useAuth } from "@/auth/useAuth";

export const useNLEmails = () => {
  const { session } = useAuth();
  const user = session?.user.user_metadata;
  const userEmail = user?.email;
  const accessToken = session?.access_token;

  const saveEmail = async (
    subject: string,
    body: string,
    email: string,
    recipients: string[],
    resend_id: string
  ) => {
    if (!accessToken) {
      throw new Error("Missing auth token for saveEmail");
    }

    const response = await fetch(
      "https://supabase-worker.marsescobin.workers.dev/api/newsletter-emails",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ subject, body, email, recipients, resend_id }),
      }
    );
    return response.json();
  };

  const getEmails = async () => {
    if (!accessToken) {
      return [];
    }

    try {
      const response = await fetch(
        `https://supabase-worker.marsescobin.workers.dev/api/newsletter-emails?email=${encodeURIComponent(
          userEmail
        )}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch emails");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error in getEmails:", error);
      return [];
    }
  };

  const sendEmail = async (
    subject: string,
    body: string,
    recipients: string[]
  ) => {
    try {
      const payload = {
        subject,
        body,
        recipients,
        email: userEmail,
      };

      console.log("Email payload being sent:", payload);

      const response = await fetch(
        "https://supabase-worker.marsescobin.workers.dev/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response.text();
        console.log("API Error Response:", errorData);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      console.log(data);
      saveEmail(subject, body, userEmail, recipients, data.data.id);

      return data;
    } catch (error) {
      console.error("Error sending email:", error);
      throw error;
    }
  };

  return { saveEmail, sendEmail, getEmails, userEmail };
};
